import { IonPage, useIonViewWillEnter } from '@ionic/react';
import { RouteComponentProps } from 'react-router';

import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { useAuthFlow } from '../../shared';
import { ProfileNeedUpdateWidget } from '../../widgets';
import React from 'react';

type NeedUpdatePersonalDataProps = RouteComponentProps;

export function NeedUpdatePersonalDataPage({ history }: NeedUpdatePersonalDataProps) {
  const { authUser } = useAuthFlow();

  useIonViewWillEnter(() => {
    if (!authUser) {
      history.push(PublicRoutes.AUTH);
      return;
    }
  }, []);

  const handleSubmit = () => {
    history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_DOB);
  };

  return (
    <IonPage>
      <ProfileNeedUpdateWidget onSubmit={handleSubmit} />
    </IonPage>
  );
}
